import { getArchiveLogList, getLogList, getLogTypeList } from '../services';

export default {
  namespace: 'LogManage',
  state: {},
  effects: {
    *getLogTypeList({ payload }, { call }) {
      const result = yield call(getLogTypeList, payload);
      return result;
    },

    *getLogList({ payload }, { call }) {
      const result = yield call(getLogList, payload);
      return result;
    },

    *getArchiveLogList({ payload }, { call }) {
      const result = yield call(getArchiveLogList, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
